import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

function RankingList({ category }) {
  const [rankings, setRankings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRankings();
    // 设置定时刷新
    const interval = setInterval(fetchRankings, 30000); // 每30秒刷新一次
    return () => clearInterval(interval);
  }, [category]);

  const fetchRankings = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/rankings?category=${category}`);
      setRankings(response.data);
    } catch (error) {
      console.error('Error fetching rankings:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <span className="loading loading-spinner loading-lg text-pink-500"></span>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <h2 className="text-2xl font-bold text-center mb-6 text-pink-500">
        {category === 'flower' ? '校花' : '校草'}排名
      </h2>
      <div className="space-y-4">
        {rankings.length === 0 ? (
          <div className="text-center text-gray-500">暫時沒有排名</div>
        ) : (
          rankings.map((candidate, index) => (
            <div
              key={candidate.id}
              className="flex items-center p-3 bg-white rounded-lg shadow hover:shadow-md transition-shadow border border-pink-100"
            >
              <div className="flex-shrink-0 w-12 h-12">
                <img
                  src={`${API_URL}${candidate.photo_url}`}
                  alt={candidate.name}
                  className="w-full h-full rounded-full object-cover border-2 border-pink-200"
                />
              </div>
              <div className="ml-4 flex-grow">
                <div className="flex items-center justify-between">
                  <div>
                    <span className="font-semibold text-gray-800">{`${index + 1}. ${candidate.name}`}</span>
                    <div className="text-sm text-gray-500">
                      分數: {candidate.score.toFixed(2)}
                    </div>
                  </div>
                  {index === 0 && (
                    <div className="badge bg-pink-500 text-white border-none">
                      👑 {category === 'flower' ? '校花' : '校草'}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default RankingList;
